type MissingDiseaseMessageInput = {
  page: string;
  searchTerm: string;
  synonyms?: string;
};

// The support team reads this in English, whatever the patient's language.
export const buildMissingDiseaseMessage = ({
  searchTerm,
  synonyms,
  page,
}: MissingDiseaseMessageInput): string =>
  [
    `Search term: ${searchTerm.trim()}`,
    `Other names: ${synonyms?.trim() || '-'}`,
    `Page: ${page}`,
  ].join('\n');
